import { useEffect, ReactNode } from "react";
import { ThemeContext } from "./theme-context";

export const ThemeProvider = ({ children }: { children: ReactNode }) => {
  useEffect(() => {
    // Always apply violet theme
    document.documentElement.classList.add("theme-violet");
  }, []);

  return (
    <ThemeContext.Provider value={{ themeStyle: "violet" }}>
      {children}
    </ThemeContext.Provider>
  );
};
